import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import CurrentAthletePill from './CurrentAthletePill';
import GlobalQuickSearch from './GlobalQuickSearch';
import { RouteGuide } from './GuideOverlay';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchUnreadCount = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/announcements/unread-count`,
        {
          headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
        }
      );
      if (response.ok) {
        const data = await response.json();
        setUnreadCount(data.unread_count);
      }
    } catch (error) {
      console.error('Error fetching unread count:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <Sidebar unreadCount={unreadCount} onCollapseChange={setSidebarCollapsed} />
      <CurrentAthletePill userRole={user?.role} />
      {/* Global Cmd+K quick search — single mount. The component itself hides
          its visible trigger on mobile via internal classes, and the document-level
          keydown listener works on every screen size. */}
      <div className="fixed top-3 right-3 z-40 pointer-events-none">
        <div className="pointer-events-auto">
          <GlobalQuickSearch />
        </div>
      </div>
      <main
        className={`transition-all duration-200 ${
          sidebarCollapsed ? 'lg:ml-[60px]' : 'lg:ml-60'
        } ml-0 pt-14 lg:pt-16`}
      >
        <div className="px-3 py-3 md:px-6 md:py-5 max-w-[1400px]">
          {children}
        </div>
      </main>
      <RouteGuide />
    </div>
  );
};

export default Layout;
